module.exports = __webpack_public_path__ + "static/media/riskbanner.741e0b40.png";